<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <search-safety-forms></search-safety-forms>
    <!-- end row -->
    </Layout>
</template>

<script>

import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import SearchSafetyForms from "../components/safety/searchSafetyForms.vue"
import routes from '../../../routes.js';

export default {
  page: {
    title: "manageSafetyForms",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader,
    SearchSafetyForms
  },
  data() {
    return {
      title: "Manage Safety Forms",
      name: 'manageSafetyForms',
      items: [
        {
          text: "home",
          href: '/'
        },
        {
            text: 'manage safety forms',
            href: '/production/safety/manageSafetyForms',
            active: true
        },
      ],
      routes: routes,
      
    }
  },

};

</script>